import { gql } from '@apollo/client';
// Query for validated meter reads
export const DOLLAR_JOURNAL = gql`
  query DollarJournal($monthYear: String) {
    dollarJournal(monthYear: $monthYear) {
      meter_computed_id
      meter_id
      meter_number
      vendor_name
      location
      units_delivered
      units_consumed
      prod_stat_netgen
      post_prod_stat_netgen
      percent_change_net_units
      meter_read_type
      post_prod_stat_meter_read_type
      rate
      prod_stat_cost_original
      dollar_value
      adjustments
      comments
      remediated
      approval_status
      ready_for_approval
      journal_ready_for_approval
      journal_approved_status
      journal_approver_signature
      journal_posted_date_time
      needs_netgen_validation
      gl_number
      dollar_gl_number
      admin_fee
      forecast_fee
      counter_party_fee
      admin_fee_gl_number
      forecast_fee_gl_number
      secondary_ipp_gl_number
      secondary_vendor_type
      meter_type
      rate_type
      rate_effective_from
      rate_effective_to
      agc_energy_kwh
      agc_cost
      prod_stat_cost_adjusted
      invoice_cost
      invoice_adjustments
    }
  }
`;

// Mutation for bulk update
// processAsync (WTTP-1012, reusing WTTP-933's async wrapper): optional, only meaningful
// when updates has more than one entry and at least one is an approval — routes the call
// through the background job instead of processing inline. Omitted/false is the original
// synchronous behavior, unchanged.
export const UPDATE_DOLLAR_METER_DATA_BULK = gql`
  mutation UpdateDollarMeterDataBulk($updates: [MeterDataInput!]!, $processAsync: Boolean) {
    updateDollarMeterDataBulk(updates: $updates, processAsync: $processAsync) {
      approved
      queued
      jobId
    }
  }
`;

// Polled after an async bulk update (processAsync) until status is succeeded/failed, then
// the affected rows are flipped to Approved in place — no page refresh.
export const DOLLAR_JOURNAL_BULK_APPROVAL_JOB_STATUS = gql`
  query DollarJournalBulkApprovalJobStatus($jobId: Int!) {
    dollarJournalBulkApprovalJobStatus(jobId: $jobId) {
      jobId
      status
      approvedMeterComputedIds
      errorMessage
    }
  }
`;
